import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

//Components MUi
import {
  Box,
  Collapse,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
// Additional components
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { StatusHandlerSeller } from '../handlers';
import { LetsGoBtn } from '../../../components/Buttons';
import ApiService from '../../../helpers/apiHelper';
import { dateFormattingByDateShort } from '../../../helpers/date-helpers';
import { Spinner } from '../../../components/Spinner';
import { StyledTitle } from '../../../components/StyledComponents';
import { useSnackbar } from 'notistack';
import { setIsOpenTTNModal } from '../../../redux/mainReducer';

function createTableData(
  number,
  service,
  buyer,
  buyingDate,
  qty,
  status,
  details,
  orderId,
  serviceID,
  price,
  currency
) {
  return {
    number,
    service,
    buyer,
    buyingDate,
    qty,
    status,
    details,
    orderId,
    serviceID,
    price,
    currency
  };
}

function Row(props) {
  const { row, language, userData } = props;
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiChats = new ApiService('notification/chats');
  const { enqueueSnackbar } = useSnackbar();
  const apiChangeOrderStatus = new ApiService('posts/order/change-status');
  const apiTTN = new ApiService('posts/order/add-TTN');
  // const apiChangeOrderStatus = new ApiService('/order/change-status');
  // const apiTTN = new ApiService('/order/add-TTN');

  const addTTN = (ttn) => {
    apiTTN.postDataQuery({ TTN: ttn, orderId: row.orderId }).then((response) => {
      apiChangeOrderStatus
        .updateDataQueryPost({ orderId: row.orderId, orderStatus: 'SENT' })
        .then((res) => {
          props.tableRefresh();
          dispatch(setIsOpenTTNModal({ isOpen: false, func: null }));
        })
        .catch((error) => {
          console.error(error);
          enqueueSnackbar('Сталася помилка!', { variant: 'error' });
        });
    });
  };
  const handleChangeStatus = (status) => {
    if (status === 'SENT') {
      dispatch(setIsOpenTTNModal({ isOpen: true, func: addTTN }));
    } else {
      apiChangeOrderStatus
        .updateDataQueryPost({ orderId: row.orderId, orderStatus: status })
        .then((res) => {
          props.tableRefresh();
        })
        .catch((error) => {
          console.error(error);
          enqueueSnackbar('Сталася помилка!', { variant: 'error' });
        });
    }
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="center" sx={{ borderColor: '#F5F4F4', p: '5px 10px' }}>
          <Typography sx={{ fontFamily: 'FixelText-Medium', fontSize: { xs: '14px', md: '16px' } }}>
            {row.number}
          </Typography>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ borderColor: '#F5F4F4', p: '5px 10px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {row.details?.paymentType === 'Безпечна оплата' && (
              <Typography
                onClick={() => navigate(`/${language}/service/${row.serviceID}`)}
                sx={{
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', md: '16px' },
                  cursor: 'pointer',
                  width: 'fit-content',
                  color: '#29A10E',
                  backgroundColor: '#D4ECCF',
                  borderRadius: '4px',
                  padding: '0 4px'
                }}
              >
                {row.details?.paymentType}
              </Typography>
            )}

            <Typography
              onClick={() => navigate(`/${language}/service/${row.serviceID}`)}
              sx={{
                fontFamily: 'FixelText-Medium',
                fontSize: { xs: '14px', md: '16px' },
                cursor: 'pointer',
                width: 'fit-content'
              }}
            >
              {row.service}
            </Typography>
            {row?.details && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  sx={{
                    fontFamily: 'FixelText-Medium',
                    color: '#60A5DF',
                    fontSize: { xs: '14px', sm: '16px' },
                    cursor: 'pointer',
                    width: 'max-content',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={() => setOpen(!open)}
                >
                  {!row.details?.TTN &&
                    (row?.details?.deliveryType.includes('Нова Пошта') ||
                      row?.details?.deliveryType.includes('УкрПошта')) &&
                    row.details?.paymentType === 'Безпечна оплата' && (
                      <ErrorOutlineIcon sx={{ color: '#F64D36', fontSize: '16px', mr: '5px' }} />
                    )}

                  {open ? 'Згорнути деталі' : 'Деталі замовлення'}
                </Typography>{' '}
                <IconButton
                  disableRipple
                  disableFocusRipple
                  aria-label="expand row"
                  size="small"
                  sx={{
                    color: '#60A5DF',
                    ':hover': {
                      backgroundColor: 'unset !important'
                    }
                  }}
                  onClick={() => setOpen(!open)}
                >
                  {open ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
                </IconButton>
              </Box>
            )}
          </Box>
        </TableCell>
        <TableCell
          align="left"
          sx={{ display: { xs: 'none', sm: 'table-cell' }, borderColor: '#F5F4F4', p: '5px 10px' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant="subtitle"
              sx={{
                fontFamily: 'FixelText-Regular !important',
                fontSize: { xs: '14px', md: '16px' },
                textAlign: 'left',
                cursor: 'pointer',
                color: '#60A5DF'
              }}
              onClick={() => {
                navigate(`/${language}/user-page/${row.buyer.id}?type=posts`);
              }}
            >
              {`@${row.buyer?.nickname}`}
            </Typography>
          </Box>
        </TableCell>

        <TableCell align="left" sx={{ borderColor: '#F5F4F4', p: '5px 10px' }}>
          <Typography sx={{ fontSize: { xs: '14px', md: '16px' } }}>
            {`${row?.price ? row?.price : ''} ${row?.currency ? row?.currency : ''}`}
          </Typography>
        </TableCell>
        <TableCell align="left" sx={{ borderColor: '#F5F4F4', p: '5px 10px' }}>
          <Typography sx={{ fontSize: { xs: '14px', md: '16px' } }}>{row.qty}</Typography>
        </TableCell>
        <TableCell align="left" sx={{ borderColor: '#F5F4F4', p: '5px 10px' }}>
          {StatusHandlerSeller(row.status, handleChangeStatus)}
        </TableCell>
      </TableRow>
      <TableRow>
        {row?.details && (
          <TableCell style={{ padding: '0px' }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Grid
                container
                sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row' } }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    width: { xs: '280px', sm: '240px', md: '430px' },
                    maxWidth: { xs: '280px', sm: '240px', md: '430px' },
                    minWidth: { xs: '280px', sm: '240px', md: '430px' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    pl: { xs: 5, md: 6 }
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Дата замовлення:
                  </Typography>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                    {row.buyingDate}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Тип оплати:
                  </Typography>

                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                    {row.details.paymentType}
                  </Typography>
                  {row.details.comment.length !== 0 && (
                    <>
                      <Typography
                        sx={{
                          fontFamily: 'FixelText-Medium',
                          fontSize: { xs: '12px', sm: '14px' },
                          fontWeight: '600'
                        }}
                      >
                        Коментар до замовлення:
                      </Typography>
                      <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                        {row.details.comment}
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    width: { xs: '300px', sm: 'unset', md: 'unset' },
                    maxWidth: { xs: '300px', sm: 'unset', md: 'unset' },
                    minWidth: { xs: '300px', sm: 'unset', md: 'unset' },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    justifyContent: 'start',
                    mb: 2,
                    pl: { xs: 5, sm: 0 }
                  }}
                >
                  <Typography
                    sx={{
                      display: { xs: 'block', sm: 'none' },
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Замовник:
                  </Typography>
                  <Typography
                    sx={{
                      display: { xs: 'block', sm: 'none' },
                      fontFamily: 'Public Sans,sans-serif !important',
                      fontSize: { xs: '12px', sm: '14px' },
                      textAlign: 'left',
                      cursor: 'pointer',
                      color: '#60A5DF'
                    }}
                    onClick={() => {
                      navigate(`/${language}/user-page/${row.buyer.id}?type=posts`);
                    }}
                  >
                    {`@${row.buyer?.nickname}`}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Контактні дані:
                  </Typography>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                    {row.details.contacts}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Адреса:
                  </Typography>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                    {row.details.deliveryType}
                  </Typography>
                  {(row?.details?.deliveryType.includes('Нова Пошта') ||
                    row?.details?.deliveryType.includes('УкрПошта')) && (
                    <>
                      {' '}
                      <Typography
                        sx={{
                          fontFamily: 'FixelText-Medium',
                          fontSize: { xs: '12px', sm: '14px' },
                          fontWeight: '600'
                        }}
                      >
                        ТТН:
                      </Typography>
                      <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                        {row.details?.TTN ? row?.details?.TTN : 'Відсутній'}
                      </Typography>
                      {!row?.details?.TTN && row.details?.paymentType === 'Безпечна оплата' && (
                        <Typography
                          sx={{
                            fontSize: {
                              xs: '12px',
                              sm: '14px',
                              color: '#F64D36',
                              width: '215px'
                            }
                          }}
                        >
                          Щоб додати ТТН, змініть статус замовлення на “Відправлено”
                        </Typography>
                      )}
                    </>
                  )}

                  <LetsGoBtn
                    lineHeight={{ xs: '14px', sm: '20px' }}
                    colorScheme="blue"
                    margin="10px 0px 0px"
                    width={{ xs: '160px', sm: '210px' }}
                    onClick={() => {
                      apiChats
                        .postDataQuery({
                          userId: userData.id,
                          recipientId: row.buyer.id
                        })
                        .then((res) => {
                          navigate(`/${language}/messages`);
                        })
                        .catch((error) => {
                          if (error?.message.includes('There is a chat between these users')) {
                            const id = `${error.message.slice(
                              error.message.indexOf('[') + 1,
                              error.message.length - 1
                            )}`;

                            navigate(`/${language}/messages?chatId=${id}`);
                          }
                        });
                    }}
                    text="Написати замовнику"
                  />
                </Grid>
              </Grid>
            </Collapse>
          </TableCell>
        )}
      </TableRow>
    </React.Fragment>
  );
}

function Orders({ language, data, userData, countSetter, blockedUsers, ...props }) {
  // eslint-disable-next-line
  const apiMyOrders = new ApiService('posts/scheduler/orders');
  // const apiMyOrders = new ApiService('/scheduler/orders');

  // const rows = [
  //   createTableData('01', 'Frozen yoghurt', mockUser, '24/08/2022', '4 oд.', 'new', {
  //     about: 'Frozen yoghurt',
  //     contacts: 'Василь Симоненко, +380967438945',
  //     deliveryType: 'Нова Пошта, м. Дніпро, відділення 42',
  //     paymentType: 'Часткова передоплата',
  //     comment: 'Хочу подарункову упаковку'
  //   }),
  //   createTableData('02', 'Ice cream sandwich', mockUser, '24/08/2022', '4 oд.', 'sent'),
  //   createTableData('03', 'Eclair', mockUser, '24/08/2022', '4 oд.', 'processing'),
  //   createTableData('04', 'Cupcake', mockUser, '24/08/2022', '4 oд.', 'done'),
  //   createTableData('05', 'Gingerbread', mockUser, '24/08/2022', '4 oд.', 'canceled')
  // ];
  // eslint-disable-next-line
  const [params, setParams] = useSearchParams();
  const [rows, setRows] = useState([]);
  const [from, setFrom] = useState(0);
  const [pages, setPages] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const [isLoading, setIsLoadiang] = useState(false);

  const dataSetter = () => {
    setIsLoadiang(true);
    apiMyOrders
      .getAll({
        from: 0,
        size: 5,
        search: params.get('question') ? params.get('question') : '',
        sortOrder: params.get('sd') ? params.get('sd') : 'DESC',
        status: params.get('status') ? params.get('status') : '',
        sortBySecurityPayment: params.get('sf') === 'true'
      })
      .then((res) => {
        const preparedRows = res.result.map((order) =>
          createTableData(
            order?.orderNumber,
            order?.service?.nameService,
            order?.buyer,
            dateFormattingByDateShort(new Date(order?.buyingDate)),
            `${order?.qty} од.`,
            order?.status,
            {
              about: order?.service?.nameService,
              contacts: order?.details?.contact,
              deliveryType: order?.details?.deliveryType,
              paymentType: order?.details?.paymentType,
              comment: order?.details?.comment,
              TTN: order?.details?.TTN
            },
            order?.id,
            order?.service?.id,
            order?.price,
            order?.currency
          )
        );
        setRows(preparedRows);
        setIsLoadiang(false);
        const countPages = Number.isInteger(res.count / 5)
          ? res.count / 5
          : Math.floor(res.count / 5) + 1;

        setPages(countPages);
        countSetter({
          new: res?.newCounter,
          sentAwait: res?.processingCounter,

          safe: res?.securityPayment
        });

        // setContentMaxCount(res.totalElements);
      })
      .catch((error) => {
        setIsLoadiang(false);
        console.error(error);
      });
  };
  const tableRefresh = () => {
    setIsLoadiang(true);
    apiMyOrders
      .getAll({
        from: from,
        size: 5,
        search: params.get('question') ? params.get('question') : '',
        sortOrder: params.get('sd') ? params.get('sd') : 'DESC',
        status: params.get('status') ? params.get('status') : '',
        sortBySecurityPayment: params.get('sf') === 'true'
      })
      .then((res) => {
        const preparedRows = res.result.map((order) =>
          createTableData(
            order?.orderNumber,
            order?.service?.nameService,
            order?.buyer,
            dateFormattingByDateShort(new Date(order?.buyingDate)),
            `${order?.qty} ${order?.service?.initOfMeasure}.`,
            order?.status,
            {
              about: order?.service?.nameService,
              contacts: order?.details?.contact,
              deliveryType: order?.details?.deliveryType,
              paymentType: order?.details?.paymentType,
              comment: order?.details?.comment,
              TTN: order?.details?.TTN
            },
            order?.id,
            order?.service?.id,
            order?.price,
            order?.currency
          )
        );
        setRows(preparedRows);
        countSetter({
          new: res?.newCounter,
          sentAwait: res?.processingCounter,
          safe: res?.securityPayment
        });
        setIsLoadiang(false);
      })
      .catch((error) => {
        setIsLoadiang(false);
        console.error(error);
      });
  };
  const handleChangePage = (page) => {
    apiMyOrders
      .getAll({
        from: 5 * (page - 1),
        size: 5,
        search: params.get('question') ? params.get('question') : '',
        sortOrder: params.get('sd') ? params.get('sd') : 'DESC',
        status: params.get('status') ? params.get('status') : '',
        sortBySecurityPayment: params.get('sf') === 'true'
      })
      .then((res) => {
        const preparedRows = res.result.map((order) =>
          createTableData(
            order?.orderNumber,
            order?.service?.nameService,
            order?.buyer,
            dateFormattingByDateShort(new Date(order?.buyingDate)),
            `${order?.qty} ${order?.service?.initOfMeasure}.`,
            order?.status,
            {
              about: order?.service?.nameService,
              contacts: order?.details?.contact,
              deliveryType: order?.details?.deliveryType,
              paymentType: order?.details?.paymentType,
              comment: order?.details?.comment,
              TTN: order?.details?.TTN
            },
            order?.id,
            order?.service?.id,
            order?.price,
            order?.currency
          )
        );
        setRows(preparedRows);
        setIsLoadiang(false);
        setFrom(5 * (page - 1));
        countSetter({
          new: res?.newCounter,
          sentAwait: res?.processingCounter,
          safe: res?.securityPayment
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    dataSetter();
    // eslint-disable-next-line
    return () => {
      setFrom(0);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <TableContainer
        component={Paper}
        sx={
          rows.length !== 0
            ? {
                borderRadius: '5px 5px 0px 0px !important',
                mt: 2.4,
                border: '2px solid #F5F4F4',
                borderBottom: 'none !important'
              }
            : {
                borderRadius: '5px 5px 0px 0px !important',
                mt: 2.4,
                backgroundColor: 'transparent !important',
                border: '2px solid #F5F4F4',
                borderBottom: 'none !important'
              }
        }
      >
        <Table aria-label="collapsible table">
          <TableHead sx={{ background: '#E2F2FF' }}>
            <TableRow>
              <TableCell
                align="center"
                sx={{
                  width: { xs: '20px !important', sm: '40px', md: '50px' },
                  maxWidth: { xs: '20px !important', sm: '40px', md: '50px' },
                  minWidth: { xs: '20px !important', sm: '40px', md: '50px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                №
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  width: { xs: '150px', sm: '200px', md: '300px' },
                  maxWidth: { xs: '150px', sm: '200px', md: '300px' },
                  minWidth: { xs: '150px', sm: '200px', md: '300px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Товар
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  display: { xs: 'none', sm: 'table-cell' },
                  width: '220px',
                  maxWidth: '220px',
                  minWidth: '220px',
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Замовник
              </TableCell>

              <TableCell
                align="left"
                sx={{
                  width: { xs: '100px', md: '150px' },
                  maxWidth: { xs: '100px', md: '150px' },
                  minWidth: { xs: '100px', md: '150px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Сума
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  width: { xs: '80px', sm: '100px' },
                  maxWidth: { xs: '80px', sm: '100px' },
                  minWidth: { xs: '80px', sm: '100px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Кількість
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  width: { xs: '110px', sm: '125px', md: '150px' },
                  maxWidth: { xs: '110px', sm: '125px', md: '150px' },
                  minWidth: { xs: '110px', sm: '125px', md: '150px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Статус
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'transparent !important' }}>
            {!isLoading ? (
              <>
                {rows.length !== 0 ? (
                  rows.map((row, index) => (
                    <Row
                      key={`${row.service + index}`}
                      row={row}
                      language={language}
                      userData={userData}
                      tableRefresh={tableRefresh}
                      blockedUsers={blockedUsers}
                    />
                  ))
                ) : (
                  <TableCell
                    style={{ paddingBottom: 200, paddingTop: 200 }}
                    sx={{ backgroundColor: 'transparent', borderBottom: 'none' }}
                    colSpan={6}
                  >
                    <Grid
                      container
                      sx={{
                        maxWidth: '100%'
                        // mt: '20% !important'
                      }}
                      spacing={3}
                    >
                      <Grid item xs={12} sx={{ paddingBottom: '0px' }}>
                        <StyledTitle
                          maxWidth={800}
                          sx={{
                            lineHeight: '38px !important',
                            fontSize: '32px !important',
                            textTransform: 'initial !important',
                            margin: '0px auto 20px !important'
                          }}
                          className="bottomBlock-title"
                        >
                          Тут порожньо
                        </StyledTitle>
                      </Grid>
                      <Grid item xs={12} sx={{ mt: 0, display: 'flex', justifyContent: 'center' }}>
                        <Typography textAlign="center" sx={{ maxWidth: '640px' }}>
                          Поки що у вас немає замовлень.
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                )}
              </>
            ) : (
              <TableCell style={{ paddingBottom: 200, paddingTop: 200 }} colSpan={6}>
                <Spinner />
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows.length !== 0 && !isLoading && (
        <Pagination
          sx={{
            mt: 0,
            mb: 0,
            p: '8px',
            borderTop: 'none',
            border: '2px solid #F5F4F4',
            borderRadius: '0px 0px 5px 5px',
            backgroundColor: 'white',
            display: 'flex',
            justifyContent: 'end',
            '& ul > li > button:not(.Mui-selected)': {
              backgroundColor: 'transparent',
              color: 'gray',
              borderColor: `gray!important`,
              margin: 1
            },
            '& .MuiPaginationItem-root': {
              color: 'gray',
              fontSize: '18px'
            },
            '& .Mui-selected': {
              backgroundColor: 'transparent',
              color: '#60A5DF',
              borderColor: '#60A5DF'
            }
          }}
          count={pages}
          defaultPage={1}
          siblingCount={2}
          variant="outlined"
          shape="rounded"
          onChange={(event, value) => {
            if (selectedPage !== +value) {
              setSelectedPage(+value);
              handleChangePage(value);
            } else {
            }
          }}
        />
      )}
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    blockedUsers: state.global.blockedUsers
  };
};

export default connect(mapStateToProps)(Orders);
